import { render, staticRenderFns } from "./payFoodOrder.vue?vue&type=template&id=6867c66a&scoped=true"
import script from "./payFoodOrder.vue?vue&type=script&lang=js"
export * from "./payFoodOrder.vue?vue&type=script&lang=js"
import style0 from "./payFoodOrder.vue?vue&type=style&index=0&id=6867c66a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6867c66a",
  null
  
)

export default component.exports